import paneer from "./../../Assets/images/Dairy/paneer.png";
import cheese from "./../../Assets/images/Dairy/cheese.png";
import FreshCheese from "./../../Assets/images/Dairy/cheese_1.png";
import watermelon from "../../Assets/images/Products/Shop-1.webp";
import tomato from "../../Assets/images/Products/Shop-2.webp";
import coriander from "../../Assets/images/Products/Shop-3.webp";


const DairyData =[
    {
        id: 1112,
        title: "Paneer",
        img: paneer,
        price: 60,
        rating: 4,
      },
      {
        id: 1113,
        title: "Cheese",
        img: cheese,
        price: 40,
        rating: 3,
      },
      {
        id: 1114,
        title: "Fresh Cheese",
        img: FreshCheese,
        price: 150,
        rating: 4,
      },
      {
        id: 1212,
        title: "Watermelon",
        img: watermelon,
        price: 60,
        rating: 4,
      },
      {
        id: 1213,
        title: "Tomato",
        img: tomato,
        price: 40,
        rating: 3,
      },
      {
        id: 1214,
        title: "Coriander",
        img: coriander,
        price: 150,
        rating: 4,
      },
]
export default DairyData;